/**
 * Convierte un string en mayúsculas a Title Case, manejando casos especiales
 * @param {string} str - String en mayúsculas a convertir
 * @returns {string} String en formato Title Case
 */
export const ucFirst = (str) => {
  if (!str || typeof str !== 'string') return str;
  const minorWords = ['de', 'del', 'la', 'las', 'el', 'los', 'y', 'o', 'con', 'sin', 'por', 'para', 'en', 'a', 'al'];
  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      if (minorWords.includes(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
